// extracted by mini-css-extract-plugin
export default {"tabs":"SearchResult_tabs__Zf+8Y"};